import { DEVICE_TYPE } from '../resources/const'
import { removeNullishProperty } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'

export const BRAZE_IAM_ALLOWED_PATHS = [
  '/',
  '/player/vod',
  '/player/movie',
  '/search',
  '/my/subscription_ticket',
]

export const convertAmountToNumber = (amount) => {
  const result = parseInt(`${amount}`.replace(/,/g, ''))
  return isNaN(result) ? undefined : result
}
export const getPurchaseProperties = (origin) => {
  const result = removeNullishProperty({
    product_id: origin.productId,
    price: convertAmountToNumber(origin.price),
    currency: 'KRW',
    device_type: DEVICE_TYPE.get('pc'),
  })
  if (origin.amount) {
    result.pg_amount = convertAmountToNumber(origin.amount)
  }
  return result
}

export const normalizePurchaseParams = (origin) => {
  const { productid: productId, amount } = origin

  return {
    productId,
    // 결제 완료시 payletter에서 실제 이용권 금액정보가 amount라는 파라미터로 넘어오기 때문에 price로 이름 변경
    price: convertAmountToNumber(amount),
  }
}

export const getUserExternalId = () => {
  const uno = cookie.getUno()
  const profileId = cookie.getProfileId()
  if (uno === 'none' && profileId === 'none') {
    return 'none'
  }
  return `${uno}_${profileId}`
}

export const normalizePath = (path) => {
  if (path === '/index.html') return '/'
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1)
  }
  return path
}

export const isAllowedIAMPathFromUrl = (rawUrl) => {
  try {
    const url = new URL(rawUrl, 'https://www.wavve.com')
    const path = normalizePath(url.pathname)
    return BRAZE_IAM_ALLOWED_PATHS.includes(path)
  } catch (e) {
    return false
  }
}
